import pageBackground from "../../assets/media/images/background pl.webp";
import pnlCharacters from "../../assets/media/PNL-Page-Characters.png";
import circleRing from "../../assets/media/icons/Circle.png";
import framePng from "../../assets/media/border-style.png";
import ethLogo from "../../assets/media/icons/ETH-Logo-Medium.png";
import singularStarGold from "../../assets/media/SingularStarGold.png";
import sandiskIcon from "../../assets/icons/SanDisk.png";
import pokemonIcon from "../../assets/icons/Pokemon.png";
import goldIcon from "../../assets/icons/Gold.png";

/** Bundled images used on the Your PNL tab (hero, background, comparison icons). */
export const PNL_PAGE_ASSETS = [
  pageBackground,
  pnlCharacters,
  circleRing,
  framePng,
  ethLogo,
  singularStarGold,
  sandiskIcon,
  pokemonIcon,
  goldIcon,
];

export {
  pageBackground,
  pnlCharacters,
  circleRing,
  framePng,
  ethLogo,
  singularStarGold,
  sandiskIcon,
  pokemonIcon,
  goldIcon,
};
